const state = {
  dataAPI: {},

  // dataLogin: {},

  dataAkun: {},

  name: "",

  namaUser: "",

  dataDashboard: {},

  dataPassword: {},

  dataOtp: "",

  dataAfterPost: {},
};

export default state;
